<h3 class="title">
  Cliënt
  @if (client) {
    <div
      class="menu">
      <button mat-icon-button
        [disableRipple]="true"
        [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu"
        xPosition="before"
        overlapTrigger="true">
        @if (!client.isGearchiveerd()) {
          <a
            mat-menu-item
            (click)="onArchiveClick(client)">
            <mat-icon fontSet="material-icons-outlined">archive</mat-icon>
            <span>Archiveren</span>
          </a>
        }
        @if (client.isGearchiveerd()) {
          <a
            mat-menu-item
            (click)="onUnarchiveClick(client)">
            <mat-icon fontSet="material-icons-outlined">unarchive</mat-icon>
            <span>Activeren</span>
          </a>
        }
      </mat-menu>
    </div>
  }
</h3>
<form
  [formGroup]="upsertClientForm"
  (ngSubmit)="onOkClicked()">
  <mat-form-field>
    <mat-label>Voornaam</mat-label>
    <input matInput
      formControlName="voornaam"
      type="text"
      placeholder="Jan"
      required>
    @if (voornaam.hasError('notBlank')) {
      <mat-error>Verplicht</mat-error>
    }
  </mat-form-field>
  <mat-form-field>
    <mat-label>Achternaam</mat-label>
    <input matInput
      formControlName="achternaam"
      type="text"
      placeholder="Janssen"
      required>
    @if (achternaam.hasError('notBlank')) {
      <mat-error>Verplicht</mat-error>
    }
  </mat-form-field>
  <mat-form-field>
    <mat-label>Cliëntnummer</mat-label>
    <input matInput
      formControlName="clientNummer"
      type="text"
      placeholder="2020/125414"
      required>
    @if (clientNummer.hasError('notBlank')) {
      <mat-error>Verplicht</mat-error>
    }
  </mat-form-field>
  <div class="row">
    <mat-form-field class="straat">
      <mat-label>Straat</mat-label>
      <input matInput
        formControlName="straat"
        type="text"
        placeholder="Naamsestraat"
        required>
      @if (straat.hasError('notBlank')) {
        <mat-error>Verplicht</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="nummer">
      <mat-label>Nummer</mat-label>
      <input matInput
        formControlName="straatNummer"
        type="text"
        placeholder="25"
        required>
      @if (straatNummer.hasError('notBlank')) {
        <mat-error>Verplicht</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="bus">
      <mat-label>Bus</mat-label>
      <input matInput
        formControlName="bus"
        type="text"
        placeholder="B">
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field class="postcode">
      <mat-label>Postcode</mat-label>
      <input matInput
        formControlName="postcode"
        type="text"
        placeholder="3000"
        required>
      @if (postcode.hasError('notBlank')) {
        <mat-error>Verplicht</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="gemeente">
      <mat-label>Gemeente</mat-label>
      <input matInput
        formControlName="gemeente"
        type="text"
        placeholder="Leuven"
        required>
      @if (gemeente.hasError('notBlank')) {
        <mat-error>Verplicht</mat-error>
      }
    </mat-form-field>
  </div>
  @if (client) {
    <mat-form-field>
      <mat-label>Diensten</mat-label>
      <input matInput
        formControlName="diensten">
      @if (!this.client?.isGearchiveerd()) {
        <mat-icon
          matSuffix
          color="primary"
          class="edit-diensten"
          (click)="onEditDienstenClick()">
          edit
        </mat-icon>
      }
    </mat-form-field>
  }
  <div class="actions">
    <button mat-button
      color="primary"
      type="button"
      (click)="onCancelClicked()">
      Annuleer
    </button>
    <button mat-raised-button
      color="primary"
      type="submit"
      [disabled]="upsertClientForm.disabled || upsertClientForm.invalid">
      {{okLabel}}
    </button>
  </div>
</form>
